import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import statisticsService from "@/services/statistics";
import analyticsService from "@/services/analytics";
import sitesService from "@/services/site";

export const useStatisticsStore = defineStore("statistics", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchCompanyOverviewStatistics(companyId) {
    loading.value = true;
    try {
      const res = await statisticsService.getCompanyOverviewStatistics(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message || 'Failed to load overview statistics');
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchCompanySetupProgress(companyId) {
    loading.value = true;
    try {
      const res = await statisticsService.getCompanySetupProgress(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message || 'Failed to load setup progress');
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchConversationsStats({ companyId, params }) {
    loading.value = true;
    try {
      const res = await analyticsService.getConversationsAverage(companyId, params);
      return res;
    } catch (err) {
      toast.error(err?.data?.message || 'Failed to load conversation stats');
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function exportSitesGrid(payload) {
    loading.value = true;
    try {
      const res = await sitesService.exportSitesGrid(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchCompanyOverviewStatistics,
    fetchCompanySetupProgress,
    fetchConversationsStats,
    exportSitesGrid,
  };
});
